import React, { useState, useEffect } from "react";
import { IoIosCheckmark, IoIosClose } from "react-icons/io";
import { MdOutlinePending } from "react-icons/md";
import axios from "axios";
import { Link } from "react-router-dom";
import { USER_URL } from "../../constant/api";
import AdminOfferApprovalModel from "../../components/AdminModal/AdminOfferApprovalModel";
// import AdminOfferApprovalModel from "../../components/AdminModal/AdminOfferApprovalModel";
function AdminOfferApproval() {
    const [filter, setFilter] = useState("All");
    const [offerData, setOfferData] = useState([]);
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [modalStatus, setModalStatus] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await USER_URL.get(`/products/admin/special-offer/`);
            setOfferData(response.data.Data || []);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    // Function to update offer status locally
    const updateOfferStatus = (offerId, newStatus) => {
        setOfferData((prevOffers) =>
            prevOffers.map((offer) =>
                offer.id === offerId ? { ...offer, status: newStatus } : offer
            )
        );
    };

    const openModal = (offer, status) => {
        setSelectedOffer(offer);
        setModalStatus(status);
        setIsModalOpen(true);
    };

    const filters = [
        { key: "all", label: "All", value: "All" },
        { key: "approved", label: "Approved", value: "Approved", icon: <IoIosCheckmark size={20} /> },
        { key: "rejected", label: "Rejected", value: "Rejected", icon: <IoIosClose size={20} /> },
        { key: "pending", label: "Pending", value: "Pending", icon: <MdOutlinePending size={20} /> },
    ];

    return (
        <div className="w-full">
            <h1 className="text-2xl font-medium text-green-600 ">Offer Approval</h1>

            {/* Filter options */}
            <div className="flex w-full items-center justify-around border-b bg-white p-2">
                {filters.map((f) => (
                    <div
                        key={f.key}
                        onClick={() => setFilter(f.value)}
                        className={`flex cursor-pointer items-center gap-1 ${filter === f.value ? "font-bold text-brand-button-green-bg" : ""}`}
                    >
                        {f.icon} {f.label}
                    </div>
                ))}
            </div>

            {/* Main content */}
            <div className="flex flex-col my-5 gap-8 lg:flex-row">
                <div className="flex-1">
                    <div className="rounded-xl text-sm">
                        <div className="overflow-x-auto">
                            {/* Table Header */}
                            <div className="w-full space-y-4">
                                <div className="grid  grid-cols-[4rem,1fr,1fr,1fr,1fr,1fr] font-medium text-brand-button-green-bg">
                                    <div className="text-center">Item No</div>
                                    <div className="text-center">Title</div>
                                    <div className="text-center">Start Date</div>
                                    <div className="text-center">End Date</div>
                                    <div className="text-center">Status</div>
                                    <div className="text-center">Actions</div>
                                </div>
                            </div>

                            {offerData.filter((offer) => filter === "All" || offer.status === filter).map((offer, index) => (
                                <div
                                    key={index}
                                    className="grid text-[#2F2E41] min-w-[1024px]  grid-cols-[4rem,1fr,1fr,1fr,1fr,1fr] items-center gap-2 py-2"
                                >
                                    <div className="border rounded-xl p-2 text-center">{index + 1}</div>
                                    <div className="line-clamp-1 rounded-xl border p-2 text-center">{offer.title}</div>
                                    <div className="border p-2 rounded-xl text-center">{offer.start_date}</div>
                                    <div className="border p-2 rounded-xl text-center">{offer.end_date}</div>
                                    <div className={`border p-2 rounded-xl text-center ${offer.status === "Approved" ? "text-green-500" : offer.status === "Pending" ? "text-yellow-500" : "text-red-500"}`}>{offer.status}</div>
                                    <div className="flex gap-2 justify-center">
                                        <button
                                            className="border p-2 rounded-xl text-center hover:bg-green-500 text-green-500 border-green-500 hover:text-white transition"
                                            onClick={() => openModal(offer, "Approved")}
                                        >
                                            Approve
                                        </button>
                                        <button
                                            className="border p-2 rounded-xl text-center hover:bg-red-500 text-red-500 border-red-500 hover:text-white transition"
                                            onClick={() => openModal(offer, "Rejected")}
                                        >
                                            Reject
                                        </button>
                                        <div className="border p-2 rounded-xl text-center hover:bg-brand-primary text-brand-text-light hover:text-white transition ease-in-out duration-400">
                                            <Link to={`/admin/approval/offer/view/${offer.id}`}>View</Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <AdminOfferApprovalModel
                selectedOffer={selectedOffer}
                isModalOpen={isModalOpen}
                closeModal={() => setIsModalOpen(false)}
                status={modalStatus}
                onStatusUpdate={updateOfferStatus}
            />
        </div>
    );
}

export default AdminOfferApproval;
